import { Component, OnInit } from '@angular/core';
import { CandidateDataLoadState, OverviewClient, ResultSummaryDto, ResultType, } from '@shared/clients/api.generated';
import { MapAreasMapping } from '@shared/components/map/map-styles.model';
import { SidenavigationLink } from '@shared/components/sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { ExtendedElectionDto, LatestUpdatesDistrictColumnDef, LatestUpdatesDistrictDto, PartyStatusColumnDef, PartyStatusDto } from '../election-overview.model';
import { ElectionOverviewService } from "../election-overview.service";
import { TopCandidates } from "@shared/components/top-candidates/top-candidates.component";
import { SidenavigationLinkType } from "@shared/components/page-layout/page-layout.model";
import { MapAreaClickedEvent } from "@shared/components/map/map-events.model";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'valg-dk-fv-election-overview',
  templateUrl: './fv-election-overview.component.html'
})
export class FvElectionOverviewComponent implements OnInit {

  election?: ExtendedElectionDto;

  readonly SvgIcon = SvgIcon;
  public mapAreasMapping?: MapAreasMapping;

  links: SidenavigationLink[] = []

  sideNavTitleType = SidenavigationLinkType.NominationDistrict;
  parentLinkType = SidenavigationLinkType.NominationDistrict;
  resultType: ResultType = ResultType.NoResults;
  candidateDataLoadState: CandidateDataLoadState = CandidateDataLoadState.NotLoaded;

  countStatus: { name: string, percentage: number }[] = [];
  countStatusUpdated: Date | undefined;
  latestUpdatesDistrictColumnDef = LatestUpdatesDistrictColumnDef;
  latestUpdates: LatestUpdatesDistrictDto[] = [];

  partyStatusColumnDef = PartyStatusColumnDef;
  partyStatus: PartyStatusDto[] = [];

  topCandidates: TopCandidates[] = [];
  resultSummary!: ResultSummaryDto;

  constructor(
    private readonly electionOverviewService: ElectionOverviewService,
    private readonly overviewClient: OverviewClient,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initializeCurrentElection();
    this.initializeConstituency();
    this.mapElectionOverview();
  }

  private async initializeCurrentElection() {
    this.election = await this.electionOverviewService.getCurrentElection();
  }

  private mapElectionOverview() {
    this.electionOverviewService.getElectionOverviewData(this.overviewClient.getGeElectionOverview())
      .subscribe(({ countStatus, resultType, countStatusUpdated, latestUpdates,
                    partyStatus, topCandidates, mapAreaMapping, candidateDataLoadState, resultSummary }) => {
        this.countStatus = countStatus;
        this.resultType = resultType;
        this.countStatusUpdated = countStatusUpdated;
        this.latestUpdates = latestUpdates;
        this.partyStatus = partyStatus;
        this.topCandidates = topCandidates;
        this.mapAreasMapping = mapAreaMapping;
        this.candidateDataLoadState = candidateDataLoadState;
        this.resultSummary = resultSummary;
      });
  }

  private initializeConstituency() {
    this.overviewClient.getElectionSideNavigation().subscribe((result) => {
      this.links = this.electionOverviewService.mapConstituencies(result);
    })
  }

  async onAreaClick($event: MapAreaClickedEvent) {
    const id = $event.data?.id;
    if (id) {
      const link = this.electionOverviewService.getNominationDistrictLink(id);
      await this.router.navigate([ link ], {
        relativeTo: this.route,
      }
    );
    }
  }
}
